import { useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom-v5-compat";
import { HotelNavigationUtility, arraysAreEqual } from "@overrides/utilities";
import { getRequestedSearch, getSearch } from "../store/selectors";

export const useIsSameSearch = () => {
  const [searchParams] = useSearchParams();
  const { location } = useParams();
  const searchValues = useSelector(getSearch);
  const requestedSearch = useSelector(getRequestedSearch);

  if (!searchValues) {
    return false;
  }
  const { guests, place, dateRange, rooms } = searchValues;

  const availabilityValues =
    HotelNavigationUtility.parseLodgingParams(searchParams);
  const placeAsUrl = HotelNavigationUtility.placeLabelAndSublabelToUrl(
    place.label,
    place.subLabel
  );

  const searchType =
    requestedSearch != null
      ? searchValues.searchType === requestedSearch.searchType
      : true;

  const isSameSearch =
    availabilityValues.adults === guests.adults &&
    arraysAreEqual(availabilityValues.children, guests.children) &&
    availabilityValues.rooms === rooms &&
    availabilityValues.fromDate === dateRange.from &&
    availabilityValues.untilDate === dateRange.until &&
    location === placeAsUrl &&
    searchType;

  return isSameSearch;
};
